export default __webpack_public_path__ + "static/media/py.3a8059fd.svg";